const Form071TC = {
    stepName: {
        statement: "重要事項",
        basicInfor: "基本資料",
        promotion: "晉升安排詳情",
        certification: "聲明",
        noteInformation: "備註資料",
        application: "教職員編制及在職人數表附件",
        promotionSupplementary: "教職員晉升事宜 ─ 補充頁",
        confirmation: "確認",
    },
    errorMsg: {
        date: {
            afterThisDate: "請在 {{name}} {{targetDate}} 之後選擇日期",
        },
        year: "下次增薪年份應為晉升生效日期的那一年或者之後的那一年",
        equal4: "請輸入4位數的學校代碼",
        equal8: "請輸入8位數的員工檔號",
    },
    label: {
        note: "備註",
        statement: "個人資料收集聲明",
        termsCon1: "本人已閱讀「個人資料收集聲明」及完全明白其內容。",
        termsCon2: "本人明白需透過「智方便+」帳戶以辧理申請。",
        schoolInfor: "基本資料",
        basicInfoNote1: "每份表格只適用於一項晉升安排。",
        basicInfoNote2: "請在填寫前，詳細閱讀個人資料收集聲明。",
        basicInfoNote3:
            "請確保教職員知悉所填報的內容，並已閱讀個人資料收集聲明。",
        basicInfoNote4:
            "教育局將會對每份晉升申請作出編制預先核查。如有關晉升人員於委任日已超逾該校的核准教學／非教學人員編制，在釐清該晉升安排是否符合編制人數之前，該薪金津貼將不會發放給學校。",
        staffInfor: "晉升安排詳情",
        schName: "學校名稱",
        schCode: "學校代碼",
        schProgram: "授課時間",
        contactPerson: "學校聯絡人",
        telNumber: "電話號碼",
        andTel: "及其電話號碼",
        enquiry: "（以便教育局處理本表格時作查詢之用）",
        management: "校董會／法團校董會",
        referenceNumber: "檔號",
        referenceNo: "檔號",
        date: "日期",
        committee1: "",
        committee2: "已批准下列晉升安排﹝檔號",
        committee3: "及日期：",
        committee4: "﹞，而有關人員的薪金資料需因此而作出以下的改動：",
        nameEnlish: "教職員英文姓名",
        nameChinese: "教職員中文姓名",
        HKICNo: "香港身份證號碼",
        SRN: "員工檔號",
        schoolHead: "校長",
        effectiveDate: "生效日期",
        effectiveDtNote:
            "在晉升職位的生效日期前須完成所需的程序（包括校董會／法團校董會的批准）。在一般情況下，晉升職位的生效日期不具追溯效力。",
        incrementalDate: "增薪日期",
        nextIncrementalYear: "下次增薪年份",
        nextIncrementalDate: "下次增薪日期",
        maximumSalary: "頂薪點（總薪級表薪點）",
        responsibilities: "上述教職員的專責職務為",
        responsibility: "職務",
        fileRefNo: "檔號",
        fileDate: "文檔日期",
        andDate: "及日期",
        approvalLetter: "批准信",
        SSDO: "高級學校發展主任",
        ssdo: "學校所屬的教育局區域教育服務處﹝經辦人：高級學校發展主任（",
        ssdo1: "）﹞",
        attachmentFor: "{{school}}附件",
        attachment: "附件",
        annex: "點擊此處下載附件表格",
        type: "學校附件（普通小學／普通中學／特殊學校）",
        supervisorName: "校監姓名",
        note3: "在<u>附件</u>內的教職員編制及在職人數表顯示有空缺作出上述晉升安排。",
        note5: "有關助理教席／高級助理教席的晉升，上述教師應在2019／20學年之前已在非學位教師職系署任有關有待實任的職位。在2019／20學年以後，非學位職系教師的晉升機制將不獲保留。換句話說，除上述情況外，非學位教師職系不應該有任何新的晉升及署任(有待實任)安排。",
        note6: "本人現確認在本表格第1至5段內所載的資料均正確無誤。本人承諾有關晉升事宜不會令擔任晉升職級的教學／非教學人員的人數超逾已核准的編制。本人並承諾本校會把多付的薪金津貼退還教育局。",
        promotion: "有關校長職位的晉升，請提供已獲教育局事先批准的詳情：",
        establishment: "教職員編制及在職人數表",
        title: "正本：",
        title1: "教育局公積金組",
        title2: "副本：",
        title3: "學校所屬的教育局區域教育服務處﹝經辦人： 高級學校發展主任",
        title4: "﹞",
        title5: "第二副本：",
        title6: "學校存檔",
        fileDateWarningMsg:
            "校長職位的晉升必須事先獲教育局批准。如有查詢，請聯絡有關學校發展主任。",
        certificationCheckboxText: "本人已參閱、明白並同意上述條款及細則",
        dialogText: "請先選擇對應的學校附件",
        personalParticulars: "(i) 個人資料",
        promotionRank: "(ii) 晉升職級",
        promotionRequirement: "(iii) 完成教師晉升培訓要求",
        promotionRequirementMsg:
            "本人確認在晉升日期起計的過去五年內已完成符合晉升至有關晉升職級的培訓課程，包括核心部分課程及符合要求時數的選修部分課程。",
        titleText: "稱謂",
    },
    table: {
        salary: "薪金",
        maxPoint: "（總薪級表薪點）",
        rank: "職級",
        before: "晉升前",
        after: "晉升後",
    },
    programValue: {
        am: "上午",
        pm: "下午",
        wholeDay: "全日",
    },
    typeValue: {
        Primary: "普通小學",
        Secondary: "普通中學",
        Special: "特殊學校",
    },
    SMCValue: {
        school: "校董會",
        incorporated: "法團校董會",
    },
    SSDOValue: {
        0: "北區",
        1: "葵青區",
        2: "西貢區",
        3: "東區",
        4: "屯門區",
        5: "九龍城區",
        6: "觀塘區",
        7: "南區",
        8: "油尖旺區",
        9: "荃灣區",
        10: "沙田區",
        11: "深水埗區",
        12: "大埔區",
        13: "灣仔區",
        14: "離島區",
        15: "中西區",
        16: "元朗區",
        17: "黃大仙區",
    },
    dateValue: {
        1: "01/01",
        2: "01/02",
        3: "01/03",
        4: "01/04",
        5: "01/05",
        6: "01/06",
        7: "01/07",
        8: "01/08",
        9: "01/09",
        10: "01/10",
        11: "01/11",
        12: "01/12",
    },
    salaryValue: {
        0: "0",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13",
        14: "14",
        15: "15",
        16: "16",
        17: "17",
        18: "18",
        19: "19",
        20: "20",
        21: "21",
        22: "22",
        23: "23",
        24: "24",
        25: "25",
        26: "26",
        27: "27",
        28: "28",
        29: "29",
        30: "30",
        31: "31",
        32: "32",
        33: "33",
        34: "34(33A)",
        35: "35(33B)",
        36: "36(33C)",
        37: "37",
        38: "38",
        39: "39",
        40: "40",
        41: "41",
        42: "42",
        43: "43",
        44: "44",
        45: "45(44A)",
        46: "46(44B)",
        47: "47",
        48: "48",
        49: "49",
    },
    noteList: {
        note1: "在晉升職位的生效日期前須完成所需的程序（包括校董會／法團校董會的批准）。在一般情況下，晉升職位的生效日期不具追溯效力。",
        note2: "教育局將會對每份晉升申請作出編制預先核查。如有關晉升人員於委任日已超逾該校的核准教學／非教學人員編制，在釐清該晉升安排是否符合編制人數之前，該薪金津貼將不會發放給學校。",
    },
    labelStep: [
        { step: "（a）" },
        { step: "（b）" },
        { step: "（c）" },
        { step: "（d）" },
        { step: "（e）" },
        { step: "（f）" },
        { step: "（g）" },
    ],
    certificationList: {
        text1: "教育局會利用本表格所載的個人資料，作以下其中一種或多種用途︰",
        text2: "辦理與聘用有關的事宜；",
        text3: "處理發放薪金津貼及其他政府資助；",
        text4: "計算公積金的供款；",
        text5: "進行核數工作；",
        text6: "進行研究及統計資料，以便規劃教育服務；",
        text7: "處理有關教育專業人員發展的事宜；",
        text8: "執行相關《資助則例》、《教育條例》、《教育規例》及《補助／津貼學校公積金規則》的規定。",
        text9: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
        text10: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局／部門／機構披露作上述用途。",
        text11: "根據《個人資料(私隱)條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
        text12: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向有關高級學校發展主任提出。",
    },
    note: {
        note1: "在<u>附件</u>內的教職員編制及在職人數表顯示有空缺作出上述晉升安排。",
        note2: "上述獲晉升的教職員已符合相關《資助則例》及教育局通告訂明的晉升要求，包括學歷、師資培訓資歷、年資及培訓要求等。",
        note3: "如屬校長職位的晉升，是次晉升已獲教育局事先批准（檔號及日期：<u>{{refNoDate}}</u>）。",
        note4: "有關助理教席／高級助理教席的晉升，上述教師應在{{schYear}}學年之前已在非學位教師職系署任有關有待實任的職位。在{{schYear}}學年以後，非學位職系教師的晉升機制將不獲保留。換句話說，除上述情況外，非學位教師職系不應該有任何新的晉升及署任(有待實任)安排。",
        note5: "本人現確認在本表格第1至6段內及「補充頁」（晉升小學學位教師／高級學位教師／高級小學學位教師／首席學位教師適用）所載的資料均正確無誤，以及有關晉升事宜不會令擔任晉升職級的教學／非教學人員的人數超逾已核准的編制。本人承諾如有關晉升事宜不符合現行晉升要求的規定，本校會把因錯誤晉升而多付的薪金津貼退還教育局。",
    },
    rankValue: {
        PSM: "小學學位教師",
        SGM: "高級學位教師",
        SPSM: "高級小學學位教師",
        PGM: "首席學位教師",
        others: "其他",
    },
    titleValue: {
        Mr: "先生",
        Miss: "小姐",
        Ms: "女士",
    },
};
export default Form071TC;
